/* ==========================================================================
   KHAVIYAR — video guard
   Keeps every background video autoplaying, muted, looping and inline on
   every platform. Retries on tab return, page restore, viewport entry and
   the first touch or scroll, which also covers iOS Low Power Mode where the
   OS refuses all autoplay until any gesture. Videos with visible controls,
   such as product gallery players, are left alone.
   25 Oct 2026: UGC reel clips (video[data-kh-ugc]) are skipped too. They load
   lazily and pause off screen on purpose (assets/kh-ugc.js), so forcing
   preload=auto and auto-resume on them would load all eight at once.
   ========================================================================== */
(function () {
  'use strict';

  function skip(v) { return !v || v.hasAttribute('controls') || v.hasAttribute('data-kh-ugc'); }

  function guard(v) {
    if (skip(v) || v.dataset.khvg === '1') return;
    v.dataset.khvg = '1';
    try {
      v.defaultMuted = true;
      v.muted = true;
      v.setAttribute('muted', '');
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.loop = true;
      v.setAttribute('loop', '');
      v.autoplay = true;
      v.setAttribute('autoplay', '');
      if (!v.getAttribute('preload') || v.getAttribute('preload') === 'none') {
        v.setAttribute('preload', 'auto');
      }
      v.disablePictureInPicture = true;
    } catch (e) {}

    v.addEventListener('pause', function () {
      if (v.ended || v.dataset.khvgResume === '1') return;
      if (document.visibilityState !== 'visible') return;
      v.dataset.khvgResume = '1';
      window.setTimeout(function () {
        v.dataset.khvgResume = '0';
        tryPlay(v);
      }, 350);
    });
  }

  function tryPlay(v) {
    if (skip(v)) return;
    if (!v.paused && !v.ended) return;
    try {
      var p = v.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    } catch (e) {}
  }

  function all() {
    return Array.prototype.slice.call(document.querySelectorAll('video:not([controls]):not([data-kh-ugc])'));
  }

  function playAll() {
    all().forEach(function (v) { guard(v); tryPlay(v); });
  }

  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) tryPlay(en.target);
      });
    }, { threshold: 0.05 });
  }

  function observeAll() {
    if (!io) return;
    all().forEach(function (v) { io.observe(v); });
  }

  function boot() {
    playAll();
    observeAll();
  }

  boot();
  document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('pageshow', playAll);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') playAll();
  });

  ['touchstart', 'pointerdown', 'keydown', 'scroll'].forEach(function (evt) {
    window.addEventListener(evt, playAll, { once: true, passive: true, capture: true });
  });

  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      var found = false;
      muts.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes || [], function (n) {
          if (n && n.nodeType === 1 && (n.tagName === 'VIDEO' || (n.querySelector && n.querySelector('video')))) found = true;
        });
      });
      if (found) boot();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
